import React from 'react';
import { useTranslation } from 'react-i18next';
import ComparisonRadar from '../charts/ComparisonRadar';

export { comparisonRadarMetrics } from '../charts/ComparisonRadar';

export default function ReportComparisonRadar({ keys, a, b, group }) {
  const { t } = useTranslation('reports');
  return <ComparisonRadar className="rr-radar"
    axes={keys.map(key => ({ key, label: t(`modern.metrics.${key}`), values: [a[key], b[key]] }))}
    title={t('modern.radarTitle', { group: t(`modern.comparisonGroups.${group}`) })}
    description={t('modern.radarScale')} emptyText={t('modern.radarUnavailable')}
    incompleteText={t('modern.radarIncomplete')} />;
}
